/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import PlayIcon from '../icons/Play';
import Button from './Button';

import styles from '../../styles/buttons/play-pause.module.css';

const propTypes = {
    paused: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

function PlayPauseButton({ paused = false, onClick = null, className = null, ...props }) {
    return (
        <Button
            aria-label={paused ? 'Play' : 'Pause'}
            onClick={onClick}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        >
            <PlayIcon className={styles.icon} playing={!paused} />
        </Button>
    );
}

PlayPauseButton.propTypes = propTypes;

export default PlayPauseButton;
